import associadoApi, {
  AssociadoSearchResponse,
  AssociadoUpdateRequest,
} from 'api/Assessor/associado';
import eventoApi, {
  ListaEventoRequest,
  ListaEventoResponse,
} from 'api/Assessor/evento';
import { ErrorAPI } from 'api/Assessor/methods';
import parametrosApi, {
  CooperativasParametrosResponse,
  ParametroCoopRequest,
  ParametrosCoopResponse,
  ParametrosTexto,
} from 'api/Assessor/parametros';
import pautasApi, { PautaEvento, StatusResultado } from 'api/Assessor/pautas';
import quorumApi, {
  IQuorumByAGNResponse,
  IQuorumByAGOResponse,
  IQuorumRepresentantes,
  QuorumRequestAgn,
  QuorumRequestAgo,
} from 'api/Assessor/quorum';
import relatoriosApi from 'api/Assessor/relatorios';
import respostaPautaApi, {
  IAGNResponse,
  IAGOResponse,
} from 'api/Assessor/respostaPauta';
import usuarioApi, {
  ContasUsuarioResponse,
  CooperativasUsuarioResponse,
  UsuarioCadastrosRequest,
  UsuarioCadastrosResponse,
} from 'api/Assessor/usuario';
import { ErrorApi } from 'api/interfaces';
import { StatusMensagens } from 'helpers/enums/AssembleiaStatus';
import browserTrigger from 'helpers/utils/DownloadTrigger';
import { toRequest } from 'helpers/utils/RequestUtils';
import {
  getAssembleiasAssessorBffEndpoint,
  getAssembleiasAssessorEndpoint,
} from 'library/Apis';
import { ThunkAction } from 'redux-thunk';
import ApiService from 'services/ApiService';
import { getCooperative } from 'services/assessor';
import { IReducer } from 'store/Reducer';
import { ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_REPRESENTANTE } from '../AssembleiasAssessorActionTypes';
import { PaginationParams, ThunkActionAssessor } from './interfaces';

type ThunkActionDefault = ThunkAction<Promise<void>, IReducer, undefined, any>;

/*
 * UsuarioApi Actions
 */

export const assessorActionListarCooperativasUsuario = (
  callbackSuccess?: (cooperativas: CooperativasUsuarioResponse) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadindCoopertaivas',
      payload: true,
    });
    getCooperative()
      .then((resp) => {
        dispatch({
          type: 'setCooperativas',
          payload: resp.data.map((coop: any) => {
            return {
              codCooperativa: coop.codigo,
              nomeCooperativa: coop.nome,
            };
          }),
        });
        callbackSuccess &&
          callbackSuccess(
            resp.data.map((coop: any) => {
              return {
                codCooperativa: coop.codigo,
                nomeCooperativa: coop.nome,
              };
            })
          );
      })
      .catch((err) => {
        return callbackError && callbackError(err);
      })
      .finally(() => {
        dispatch({
          type: 'loadindCoopertaivas',
          payload: false,
        });
      });
  };
};

export const assessorActionBuscarCadastros = (
  request: Partial<UsuarioCadastrosRequest>,
  pagination: Partial<PaginationParams>,
  callbackSuccess: (response: UsuarioCadastrosResponse) => void,
  callbackError: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'buscandoCadastros',
      payload: true,
    });
    const { fail, data } = await usuarioApi.listagemCadastros(
      request,
      pagination.page,
      pagination.size
    );
    if (fail) {
      callbackError(fail);
    }
    if (data) {
      callbackSuccess(data);
    }
    dispatch({
      type: 'buscandoCadastros',
      payload: false,
    });
  };
};

export const assessorActionBuscarContasUsuario = (
  idUsuario: number,
  codigoCooperativa: string,
  callbackSuccess: (response: ContasUsuarioResponse) => void,
  callbackError: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'buscandoContas',
      payload: true,
    });
    const { fail, data } = await usuarioApi.contasPorUsuario(
      idUsuario,
      codigoCooperativa
    );
    if (fail) {
      callbackError(fail);
    }
    if (data) {
      callbackSuccess(data);
    }
    dispatch({
      type: 'buscandoContas',
      payload: false,
    });
  };
};

/*
 * ParametrosApi Actions
 */

export const assessorActionCarregarCooperativasParametro = (
  callbackSuccess?: (lista: CooperativasParametrosResponse) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadindCoopertaivas',
      payload: true,
    });
    const { fail, data } = await parametrosApi.cooperativas();
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: 'loadindCoopertaivas',
      payload: false,
    });
  };
};

export const assessorActionListarItensParametro = (
  size: number,
  page: number,
  callbackSuccess?: (lista: ParametrosCoopResponse) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingParametros',
      payload: true,
    });
    const { fail, data } = await parametrosApi.listar(size, page);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: 'loadingParametros',
      payload: false,
    });
  };
};

export const assessorActionAdicionarItemParametro = (
  coodCooperativa: string,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingParametros',
      payload: true,
    });
    const { fail, response } = await parametrosApi.adicionar(coodCooperativa);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (response?.status === 201) {
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: 'loadingParametros',
      payload: false,
    });
  };
};

export const assessorActionAlterarItemParametro = (
  data: ParametroCoopRequest,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingParametros',
      payload: true,
    });
    const { fail, response } = await parametrosApi.alterar(data);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (response?.status === 200) {
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: 'loadingParametros',
      payload: false,
    });
  };
};

export const assessorActionAlterarTextoParametro = (
  data: ParametrosTexto,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingParametros',
      payload: true,
    });
    const { fail, response } = await parametrosApi.alterarConfigTexto(data);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (response?.status === 200) {
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: 'loadingParametros',
      payload: false,
    });
  };
};

export const assessorActionRemoverItemParametro = (
  idParametroCoop: number,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingParametros',
      payload: true,
    });
    const { fail, response } = await parametrosApi.remover(idParametroCoop);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (response?.status === 200) {
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: 'loadingParametros',
      payload: false,
    });
  };
};

/*
 * QuorumApi Actions
 */

export const assessorActionListarQuorumPorAgn = (
  request: QuorumRequestAgn,
  callbackSuccess?: (response: IQuorumByAGNResponse) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingQuorum',
      payload: true,
    });
    const { fail, data } = await quorumApi.listarByAGN(request);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: 'loadingQuorum',
      payload: false,
    });
  };
};

export const assessorActionListarQuorumPorAgo = (
  request: QuorumRequestAgo,
  callbackSuccess?: (response: IQuorumByAGOResponse) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingQuorum',
      payload: true,
    });
    const { fail, data } = await quorumApi.listarByAGO(request);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: 'loadingQuorum',
      payload: false,
    });
  };
};

/*
 * ResultadoPautaApi Actions
 */

export const assessorActionResultadoPautaPorAgn = (
  idPauta: number,
  callbackSuccess?: (resultado: IAGNResponse) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingResultado',
      payload: true,
    });
    const { fail, data } = await respostaPautaApi.getByAGN(idPauta);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: 'loadingResultado',
      payload: false,
    });
  };
};

export const assessorActionResultadoPautaPorAgo = (
  idPauta: number,
  callbackSuccess?: (resultado: IAGOResponse) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingResultado',
      payload: true,
    });
    const { fail, data } = await respostaPautaApi.getByAGO(idPauta);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: 'loadingResultado',
      payload: false,
    });
  };
};

export const assessorActionListarRepresentantes = (
  agencia: string,
  idEvento: number,
  nucleo: string,
  callbackSuccess?: (response: IQuorumRepresentantes) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionAssessor => {
  return async () => {
    // dispatch({
    //   type: 'substituirQuorumRepresentantes',
    //   payload: true,
    // });
    const { fail, data } = await quorumApi.representantes(
      agencia,
      idEvento,
      nucleo
    );
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
    // dispatch({
    //   type: 'substituirQuorumRepresentantes',
    //   payload: false,
    // });
  };
};

export const assessorActionSubstituirRepresentantes = (
  agencia: string,
  idConvocado: number,
  idEvento: number,
  nucleo: string,
  callbackSuccess?: Function,
  callBackClose?: Function,
  callbackError?: (error: ErrorApi) => void
) => {
  return (dispatch: any) => {
    new Promise((resolve: Function, reject: (error: ErrorApi) => void) => {
      toRequest(
        ApiService.post,
        [
          `${getAssembleiasAssessorEndpoint('1')}quorum/substituir`,
          {
            agencia,
            idConvocado,
            idEvento,
            nucleo,
          },
        ],
        'save'
      ).then(
        () => {
          dispatch({
            type: ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_REPRESENTANTE,
          });
          resolve();
        },
        (error: ErrorAPI) => {
          reject(error);
        }
      );
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
        if (typeof callBackClose === 'function') {
          callBackClose();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

/*
 * RelatoriosApi Actions
 */

export const assessorActionRelatorioPresentesHistorico = (
  idEvento: number,
  fileName: string,
  callbackSuccess?: () => void,
  callbackError?: (fail: ErrorApi) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingRelatorio',
      payload: true,
    });
    const { fail, data } = await relatoriosApi.historico(idEvento);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      browserTrigger(fileName, data);
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: 'loadingRelatorio',
      payload: false,
    });
  };
};

export const assessorActionRelatorioCadastros = (
  request: Partial<UsuarioCadastrosRequest>,
  fileName: string,
  callbackError: (error: ErrorApi) => void,
  callbackSuccess?: () => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingRelatorio',
      payload: true,
    });
    const { fail, data } = await relatoriosApi.cadastros(request);
    if (fail) {
      callbackError(fail);
    }
    if (data) {
      browserTrigger(fileName, data);
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: 'loadingRelatorio',
      payload: false,
    });
  };
};

/*
 * EventoApi Actions
 */

export const assessorActionCarregarListaEventos = (
  request: Partial<ListaEventoRequest>,
  callbackSuccess: (response: ListaEventoResponse) => void,
  callbackError: (error: ErrorApi) => void
) => {
  return (dispatch: any) => {
    dispatch({
      type: 'loadingListaEventos',
      payload: true,
    });

    const url = `${getAssembleiasAssessorBffEndpoint('1')}event/search`;

    new Promise<void>((resolve: () => void) => {
      toRequest(ApiService.post, [url, request], 'getAllEvent')
        .then((response: any) => {
          resolve();
          callbackSuccess(response.data);
          dispatch({
            type: 'loadingListaEventos',
            payload: false,
          });
        })
        .catch((error) => {
          callbackError(error);
          dispatch({
            type: 'loadingListaEventos',
            payload: false,
          });
        });
    });
  };
};

export const assessorActionAlteraStatusForum = (
  idEvento: number,
  status: StatusMensagens,
  callbackError: (errror: ErrorApi) => void,
  callbackSuccess?: () => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'changingStatusForum',
      payload: true,
    });
    const { fail, response } = await eventoApi.mensagens(idEvento, status);
    if (fail) {
      callbackError(fail);
    }
    if (response?.status === 200) {
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: 'changingStatusForum',
      payload: false,
    });
  };
};

/*
 * PautasApi Actions
 */

export const assessorActionCarregarPautas = (
  idEvento: number,
  page: number,
  callbackError: (error: ErrorApi) => void,
  callbackSuccess?: (pautas: PautaEvento[]) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'loadingPautas',
      payload: true,
    });
    const { fail, data } = await pautasApi.listar({
      idEvento,
      page: page <= 0 ? 0 : page,
    });
    if (fail) {
      callbackError(fail);
    }
    if (data) {
      setTimeout(() => {
        dispatch({
          type: 'setPautas',
          payload: data,
        });
      }, 350);
      callbackSuccess && callbackSuccess(data.elements);
    }
    dispatch({
      type: 'loadingPautas',
      payload: false,
    });
  };
};

export interface PautasEmLoteType {
  agencia: string;
  dataEncerramentoDigital: string;
  id: number;
  nucleo: string;
  restrita: boolean;
  secreta: boolean;
  status: string;
  tipo: number;
  titulo: string;
}

export const assessorFilterByType = (
  idEvento: number | string | any,
  tipos: any,
  callbackSuccess?: (resultado: PautasEmLoteType[]) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionDefault => {
  return async () => {
    const { fail, data } = await pautasApi.filtrarTipoPautas(idEvento, tipos);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data as PautasEmLoteType[]);
    }
  };
};

export const assessorActionAtualizaPauta = (
  idPauta: number,
  changes: Partial<PautaEvento>,
  callbackSuccess?: () => {}
): ThunkActionAssessor => {
  return async (dispatch, getState) => {
    const _pautas = Array.from(getState().assessor.pautas!.elements);
    const target = _pautas.findIndex((pauta) => pauta.idPauta === idPauta);
    if (target < 0) return;
    _pautas[target] = Object.assign({}, _pautas[target], changes);
    dispatch({
      type: 'setPautas',
      payload: {
        ...getState().assessor.pautas!,
        elements: _pautas,
      },
    });
    callbackSuccess && callbackSuccess();
  };
};

export const assessorActionLiberaResultadoPauta = (
  idEvento: number,
  idPauta: number,
  status: StatusResultado,
  callbackError: (error: ErrorApi) => void,
  callbackSuccess?: () => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'togglingResult',
      payload: true,
    });
    const { fail, response } = await pautasApi.statusResultado(
      idEvento,
      idPauta,
      status
    );
    if (fail) {
      callbackError(fail);
    }
    if (response?.status === 200) {
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: 'togglingResult',
      payload: false,
    });
  };
};

export const assessorActionLiberarResultadoAssociado = (
  idEvento: number | string | any,
  idPauta: number,
  callbackError?: (error: ErrorApi) => void,
  callbackSuccess?: () => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'togglingResult',
      payload: true,
    });

    const { fail, response } = await pautasApi.liberarResultadoAssociado(
      idEvento,
      idPauta
    );

    if (fail && typeof callbackError === 'function') {
      callbackError(fail);
    }

    if (response?.status === 200 && typeof callbackSuccess === 'function') {
      callbackSuccess();
    }

    dispatch({
      type: 'togglingResult',
      payload: false,
    });
  };
};

/*
 * AssociadoApi Actions
 */

export const assessorActionPesquisarAssociado = (
  nomeCpfCnpj: string,
  callbackError: (error: ErrorApi) => void,
  callbackSuccess: (response: AssociadoSearchResponse) => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'procurandoAssociado',
      payload: true,
    });
    const { fail, data } = await associadoApi.search({ nomeCpfCnpj });
    if (fail) {
      callbackError(fail);
    }
    if (data) {
      callbackSuccess(data);
    }
    dispatch({
      type: 'procurandoAssociado',
      payload: false,
    });
  };
};

export const assessorActionAtualizarAssociado = (
  request: AssociadoUpdateRequest,
  callbackError: (error: ErrorApi) => void,
  callbackSuccess?: () => void
): ThunkActionAssessor => {
  return async (dispatch) => {
    dispatch({
      type: 'atualizandoAssociado',
      payload: true,
    });
    const { fail, response } = await associadoApi.update(request);
    if (fail) {
      callbackError(fail);
    }
    if (response?.status === 200) {
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: 'atualizandoAssociado',
      payload: false,
    });
  };
};
